import Header from './components/header';
import Sections from './components/section';

window.addEventListener('DOMContentLoaded', () => {
	new Header();
	new Sections();
});

$.validator.unobtrusive.options = {};
$.validator.unobtrusive.options.errorPlacement = function (err, el) {
	$(el).closest('.form__input__inp').addClass('form__input__inp--error');
}
$.validator.unobtrusive.options.success = function (err, el) {
	$(el).closest('.form__input__inp--error').removeClass('form__input__inp--error');
}

$.validator.addMethod("requiredif",
	function (value, element, parameters) {
		var targetId = parameters.otherproperty;
		var targetValue = parameters.otherpropertyvalue;

		var otherPropertyValue = (targetValue == null || targetValue == undefined ? "" : targetValue).toString();

		var otherPropertyElement = $('#' + targetId);

		if (otherPropertyElement[0].checked.toString() == otherPropertyValue.toLowerCase()) {
			if (value !== '') {
				var isValid = $.validator.methods.required.call(this, value, element, parameters);
				return isValid;
			}
			return false;
		}

		return true;
	}
);

$.validator.unobtrusive.adapters.add("requiredif", ["otherproperty", "otherpropertyvalue"],
	function (options) {
		options.rules["requiredif"] = options.params;
		options.messages["requiredif"] = options.message;
	});

$(function () {
    var locationTimer = {};
    var lastQuery = {};

    function handleGetAddressInput() {
        var $this = $(this);
        var $addressInputFormSection = $this.closest(".address-input-form-section");
        var $addressInputTriggers = $addressInputFormSection.find(".js-get-address-input-trigger");
        var $addressInputContainers = $addressInputFormSection.find(".address-input-container");

        var addressInputType = $this.data("address-input-type");

        $addressInputTriggers.hide();
        $addressInputTriggers.filter(":not([data-address-input-type='" + addressInputType + "'])").show();

        $addressInputContainers.hide();
        $addressInputContainers.filter("[data-address-input-type='" + addressInputType + "']").show();
    }

    function handleAddressLookupInput() {
        var $this = $(this);
        var id = $this.parents(".addresslookup-container")[0].id;

        if (locationTimer[id] !== undefined) {
            clearTimeout(locationTimer[id]);
        }

        locationTimer[id] = setTimeout(function () {
            performLocationQuery($this, id);
        }, 800);
    }

    function performLocationQuery(self, id) {
        var text = self.val();

        if (text === undefined || text === "") return;

        text = text.trim().toLowerCase();

        if (text === lastQuery[id]) return;
        lastQuery[id] = text;

        var $parent = $("#" + id).first();

        var $resultsDiv = $parent.find(".addresslookup-collapse-results");
        var $resultsLoad = $resultsDiv.siblings(".addresslookup-loading");

        $resultsLoad.show();

        // Fully close results so we can open it again
        $resultsDiv.removeClass("in");
        $resultsDiv.attr("aria-expanded", false);

        self.trigger("beginsearch");

        $.ajax({
            url: "/umbraco/surface/AddressInputSurface/GetLocation?s=" + encodeURIComponent(text)
        }).done(function (data) {
            self.trigger("finishsearch");

            $resultsLoad.hide();

            var resultsUl = $resultsDiv.find(".addresslookup-results-container .addresslookup-results-list ul");
            var resultsNoResults = $resultsDiv.find(".addresslookup-results-container p.addresslookup-results-none");

            if (data === undefined || data === null || data.length === 0) {
                resultsNoResults.show();
                resultsUl.parent().hide();
                $resultsDiv.collapse("show");
                return;
            }

            var addressList = "";
            for (var i = 0; i < data.length; i++) {
                var d = data[i];

                addressList += "<li data-id=\"" + d.id + "\">"
                    + d.text
                    + ((d.description && d.description.length > 0) && (", " + d.description) || "")
                    + ", " + (d.id.split("|", 1)[0] || "")
                    + "</li>";
            }

            resultsUl.html(addressList);
            resultsUl.children("li").on("click", selectAddress);

            resultsNoResults.hide();
            resultsUl.parent().show();
            $resultsDiv.collapse("show");
        });
    }

    function selectAddress() {
        var $this = $(this);
        var $parent = $this.parents(".addresslookup-container");

        var loqateId = $this.data("id");

        var $loqateIdField = $parent.find(".js-address-loqate-id-field");
        $loqateIdField.val(loqateId);

        var selectDiv = $parent.find(".addresslookup-collapse-select");
        selectDiv.find("p").text($this.text());
        selectDiv.collapse("show");

        $this.siblings().removeClass("active");
        $this.addClass("active");
    }

    function getAndSetFullAddress(addressLookupContainer, loqateId) {
        return getFullAddress(loqateId).then(function (fullAddress) {
            var collapseHelp = addressLookupContainer.find(".addresslookup-collapse-help");

            if (!fullAddress) {
                collapseHelp.find(".addresslookup-help").html("<p>Couldn't retrieve full address details. Please enter your address manually.</p>");
                collapseHelp.collapse("show");

                App.smoothScrollTo(collapseHelp);

                return false;
            }

            collapseHelp.collapse("hide");

            setFullAddress(addressLookupContainer, fullAddress);

            return true;
        });
    }

    function getFullAddress(loqateId) {
        return $.ajax({
            url: "/umbraco/surface/AddressInputSurface/GetFullAddress?loqateId=" + loqateId,
            method: "GET"
        });
    }

    function setFullAddress(addressLookupContainer, fullAddress) {
        var $addressInputFormSection = addressLookupContainer.closest(".address-input-form-section");
        var $addressInputContainers = $addressInputFormSection.find(".address-input-container");

        $addressInputContainers.find(".js-address-line-1-field").val(fullAddress.line1);
        $addressInputContainers.find(".js-address-line-2-field").val(fullAddress.line2);
        $addressInputContainers.find(".js-address-line-3-field").val(fullAddress.line3);
        $addressInputContainers.find(".js-address-city-field").val(fullAddress.city);
        $addressInputContainers.find(".js-address-county-field").val(fullAddress.provinceName);
		$addressInputContainers.find(".js-address-postcode-field").val(fullAddress.postalCode);

		debugger;
		$addressInputContainers.find(".js-address-country-field").val(fullAddress.countryName).change();
    }

    function handleSameAddressCheckbox(e) {
        e.preventDefault();
        var checked = e.target.checked || e.currentTarget.checked;
        var container = $(e.target).closest('.text.mb-4');

        var $addressForm = container.find("#address");
        var $addressBillingForm = container.find("#address-billing");

        if (checked) {
            $addressForm.show();
            $addressForm.find('input, select').attr('readonly', 'readonly');
            $addressForm.find('.choices').addClass('is-disabled');
            $addressBillingForm.hide();

            var address1 = $addressForm.find('.js-address-line-1-field');
            $addressBillingForm.find('.js-address-line-1-field').val(address1.val());

            var address2 = $addressForm.find('.js-address-line-2-field');
            $addressBillingForm.find('.js-address-line-2-field').val(address2.val());

            var addressCity = $addressForm.find('.js-address-city-field');
            $addressBillingForm.find('.js-address-city-field').val(addressCity.val());

            var addressCounty = $addressForm.find('.js-address-county-field');
            $addressBillingForm.find('.js-address-county-field').val(addressCounty.val());

            var addressPostcode = $addressForm.find('.js-address-postcode-field');
            $addressBillingForm.find('.js-address-postcode-field').val(addressPostcode.val());

            var addressCountry = $addressForm.find('.js-address-country-field');
            $addressBillingForm.find('.js-address-country-field').val(addressCountry.val()).change();
        }
        else {
            $addressForm.hide();
            $addressForm.find('input, select').removeAttr('readonly');
            $addressForm.find('.choices').removeClass('is-disabled');
            $addressBillingForm.find('input').val('').change();
            $addressBillingForm.show();
        }

        $addressForm.find('.js-get-address-input-trigger').hide();
    }

    $(document).on("click", ".js-get-address-input-trigger", handleGetAddressInput);
    $(document).on("input", ".address-input-container .addresslookup-textsearch", handleAddressLookupInput);
	$(document).on('input', ".js-same-address", handleSameAddressCheckbox);
	$(document).on('input', ".js-trim", function (e) { e.target.value = e.target.value?.trim() });

    // The only way to hook into form submission before jQuery validation
    $(".addresslookup-container").parents("form").submit(function (e) {
        var $this = $(this);

        // Get the address lookup container element, only perform additional checks if it's present
        var $parent = $this.find(".addresslookup-container");
        if ($parent.length === 0) {
            return;
        }

        e.preventDefault();

        if ($this.valid()) {
            var $loqateIdField = $parent.find(".js-address-loqate-id-field");
            if ($loqateIdField.length === 0 || !$loqateIdField.is(":visible")) {
                $loqateIdField.val('found');

                // The field for holding the Loqate Id is gone, we're likely looking at the manual address form, disregard and submit
                this.submit();

                return;
            }

            var loqateId = $loqateIdField.val();

            getAndSetFullAddress($parent, loqateId).then(function (success) {
                if (success) {
                    // All is good, submit the form (use '$this[0]' because the 'this' var may point to something else now)
                    $this[0].submit();
                }
            });
        }
    });
});

let formGoBackBtn = document.querySelector('.js-go-back');
if (formGoBackBtn) {
    formGoBackBtn.addEventListener('click', function (e) {
        e.preventDefault();

        var form = formGoBackBtn.closest('form');
        var goBackHiddenField = form.querySelector('input[id="GoBack"]');

        if (form && goBackHiddenField) {
            goBackHiddenField.value = "True";
            goBackHiddenField.dispatchEvent(new Event('change'));
            form.submit();
        }
    });
}

// This is a public sample test API key.
// Don�t submit any personally identifiable information in requests made with this key.
// Sign in to see your own test API key embedded in code samples.
let stripe;

let elements;
let options;

// Fetches a payment intent and captures the client secret
async function initializeEventBookingPayment(formId, eventId, successUrl, failureUrl, total, item) {
    checkStatus();

	console.debug("initializeEventBookingPayment");

    options = {
        formId: formId,
        eventId: eventId,
        successUrl: successUrl,
        failureUrl: failureUrl,
        total: total,
        item: item
    };

    document
        .querySelector("#payment-form")
        .addEventListener("submit", handleSubmitEventBooking);

    const response = await fetch(
        `/umbraco/surface/StripeSurface/GetPaymentIntent?amount=${options.total}&itemName=${options.item}&userJourney=Event Booking`,
        {
            method: "POST"
        });

    const { clientSecret, publicApiKey, amount } = await response.json();

    // Initialize stripe
	stripe = Stripe(publicApiKey);

    const appearance = {
        theme: "stripe"
    };

    elements = stripe.elements({ appearance, clientSecret });

    const paymentElementOptions = {
        layout: "tabs"
    };

    const paymentElement = elements.create("payment", paymentElementOptions);

    paymentElement.mount("#payment-element");
}

window.initializeEventBookingPayment = initializeEventBookingPayment;

async function initializeMembershipApplicationPayment(formId, contactId, applicationId, successUrl, failureUrl, total, item) {
    checkStatus();

    console.debug("initializeMembershipApplicationPayment");

    options = {
        formId: formId,
        contactId: contactId,
        applicationId: applicationId,
        successUrl: successUrl,
        failureUrl: failureUrl,
        total: total,
        item: item
    };

    var form = document.querySelector("#payment-form");
    form?.addEventListener("submit", handleSubmitMembershipApplication);

    const response = await fetch(
        `/umbraco/surface/StripeSurface/GetPaymentIntent?amount=${options.total}&itemName=${options.item}&applicationId=${options.applicationId}&userJourney=Membership Application`,
        {
            method: "POST"
        });

    const { clientSecret, publicApiKey, amount } = await response.json();

    stripe = Stripe(publicApiKey);

    const appearance = {
        theme: "stripe"
    };

    elements = stripe.elements({ appearance, clientSecret });

    const paymentElementOptions = {
        layout: "tabs"
    };

    const paymentElement = elements.create("payment", paymentElementOptions);

    paymentElement.mount("#payment-element");
}

window.initializeMembershipApplicationPayment = initializeMembershipApplicationPayment;

async function handleSubmitEventBooking(e) {
    e.preventDefault();

    const bookingForm = $(`#${options.formId}`)[0];

    const returnUrl =
        `${window.location.href.split("/").slice(0, 3).join("/")}/umbraco/surface/BookingSurface/SaveBookingToCrm?key=${options.eventId
        }&successUrl=${options.successUrl}&failureUrl=${options.failureUrl}`;

    // Validate form
    if (!$(bookingForm).valid()) {
        //bookingForm.reportValidity();
        return;
    } else {
        // save the form to session
        try {

            const $form = $(`#${options.formId}`);
            const formData = JSON.stringify(getFormData($form));

            await $.ajax({
                method: "POST",
                url: `/umbraco/surface/StripeSurface/SaveBookingFormToSession?key=${options.eventId}`,
                data: formData,
                dataType: "json",
                contentType: "application/json",
                cache: false,
                async: true
            });

        } catch (err) {
            console.error(err);
            return;
        }
    }

    setLoading(true);

    const { error } = await stripe.confirmPayment({
        elements,
        confirmParams: {
            return_url: returnUrl
        }
    });

    // This point will only be reached if there is an immediate error when
    // confirming the payment. Otherwise, your customer will be redirected to
    // your `return_url`. For some payment methods like iDEAL, your customer will
    // be redirected to an intermediate site first to authorize the payment, then
    // redirected to the `return_url`.
    if (error.type === "card_error" || error.type === "validation_error") {
        showMessage(error.message);
    } else {
        showMessage("An unexpected error occurred.");
    }

    setLoading(false);
}

async function handleSubmitMembershipApplication(e) {
    e.preventDefault();

    const appForm = $(`#${options.formId}`)[0];

    const returnUrl =
        `${window.location.href.split("/").slice(0, 3).join("/")}/umbraco/surface/MembershipApplicationSurface/ConfirmStripePayment?key=${options.contactId}&successUrl=${encodeURIComponent(options.successUrl)}&failureUrl=${encodeURIComponent(options.failureUrl)}`;

    // Validate form
    if (!$(appForm).valid()) {
        //appForm.reportValidity();
        return;
    } else {
        // save the form to session
        try {
            const $form = $(`#${options.formId}`);
            const formData = JSON.stringify(getFormData($form));

            await $.ajax({
                method: "POST",
                url: "/umbraco/surface/MembershipApplicationSurface/SavePaymentStep",
                data: formData,
                dataType: "json",
                contentType: "application/json",
                cache: false,
                async: true
            });

        } catch (err) {
            console.error(err);
            return;
        }
    }

    setLoading(true);

    const { error } = await stripe.confirmPayment({
        elements,
        confirmParams: {
            return_url: returnUrl
        }
    });

    // This point will only be reached if there is an immediate error when
    // confirming the payment. Otherwise, your customer will be redirected to
    // your `return_url`. For some payment methods like iDEAL, your customer will
    // be redirected to an intermediate site first to authorize the payment, then
    // redirected to the `return_url`.
    if (error.type === "card_error" || error.type === "validation_error") {
        showMessage(error.message);
    } else {
        showMessage("An unexpected error occurred.");
    }

    setLoading(false);
}

// Fetches the payment intent status after payment submission
async function checkStatus() {
    const clientSecret = new URLSearchParams(window.location.search).get(
        "payment_intent_client_secret"
    );

    if (!clientSecret) {
        return;
    }

    const { paymentIntent } = await stripe.retrievePaymentIntent(clientSecret);

    switch (paymentIntent.status) {
        case "succeeded":
            showMessage("Payment succeeded!");
            break;
        case "processing":
            showMessage("Your payment is processing.");
            break;
        case "requires_payment_method":
            showMessage("Your payment was not successful, please try again.");
            break;
        default:
            showMessage("Something went wrong.");
            break;
    }
}

// ------- UI helpers -------

function showMessage(messageText) {
    const messageContainer = document.querySelector("#payment-message");

    messageContainer.classList.remove("hidden");
    messageContainer.textContent = messageText;

    setTimeout(function () {
        messageContainer.classList.add("hidden");
        messageContainer.textContent = "";
    },
        4000);
}

// Show a spinner on payment submission

function setLoading(isLoading) {
    if (isLoading) {
        // Disable the button and show a spinner
        document.querySelector("#submit").disabled = true;
        document.querySelector("#spinner").classList.remove("hidden");
        document.querySelector("#button-text").classList.add("hidden");
    } else {
        document.querySelector("#submit").disabled = false;
        document.querySelector("#spinner").classList.add("hidden");
        document.querySelector("#button-text").classList.remove("hidden");
    }
}

function getFormData($form) {
    const unIndexedArray = $form.serializeArray();
    var indexedArray = {};

    $.map(unIndexedArray,
		function (n, i) {
            indexedArray[n["name"]] = n["value"];
        });

    return indexedArray;
}

const App = {
	defaults: {
		pageName: "Pagination.CurrentPage"
	},

	init: function () {
		// init stuff goes here

		// Load jQuery dependent inits when jQuery is ready
		$(function () {
			App.initForms();
			App.initPageReady();
		});
	},

	initForms: function () {
		function handleUsualFormReturn(form, doBlockUI) {
			if (doBlockUI) $.unblockUI();

			var importantContainer = $("form .error-container, form .success-container");

			if (importantContainer.length > 0) {
				App.smoothScrollTo(importantContainer);
			}
			else {
				// Only scroll to the form automatically if this isn't an onload submission
				var isFirstLoadSubmission = form.hasClass("js-submit-on-load") && !form.data("hasSubmittedBefore");

				if (!isFirstLoadSubmission) {
					App.smoothScrollTo(form, false, 250);
				}
			}

			form.data("hasSubmittedBefore", true);
		}

		let searchTerm_listeners = $('.js-form-listen-searchterm');
		$('.js-form-announce-searchterm').on('submit', e => {
			e.preventDefault();
			let searchTerms = $(e.currentTarget).find('#pagination-search-box');
			if (searchTerms.length > 0) {
				let searchTerm = searchTerms[0].value;
				searchTerm_listeners.each((_, listener) => listener.innerHTML = searchTerm);
				let url = new URL(window.location.href);
				url.searchParams.set('q', searchTerm);
				window.history.pushState({}, '', url);
			}
		});

		$("form.js-ajax").each(function (_, el) {
			var $el = $(el);

			if (!$el.data("hasAjaxSubmitEvent")) {
				$el.submit(function (e) {
					e.preventDefault();

					var form = $(this);
					var doBlockUI = $.blockUI && form.hasClass("js-ajax-blockui");

					if (doBlockUI) $.blockUI();

					if (form.hasClass("js-page-reset-form")) {
						App.resetFormPage(form);
					}

					App.performAjax(form,
						function (data) {
							if (data.result == "redirect") {
								window.location = data.url;
							}
							else {
								if (form.data("ajax-replace-outer")) {
									$(form.data("ajax-replace-outer")).replaceWith(data);
								}
								else if (form.data("ajax-replace")) {
									$(form.data("ajax-replace")).html(data);
								}
								else {
									form.parent().html(data);
								}

								App.initForms();

								handleUsualFormReturn(form, doBlockUI);
							}
						},
						function (xhr, textStatus, errorThrown) {
							handleUsualFormReturn(form, doBlockUI);
						});
				});

				$el.data("hasAjaxSubmitEvent", true);

				if ($el.hasClass("js-submit-on-load")) $el.submit();
			}
		});

		$(".js-submit-on-change").each(function (_, el) {
			var $el = $(el);

			if (!$el.data("hasSubmitOnChangeEvent")) {
				$el.on("change", function (e) {
					$(this).closest("form").submit();
				});

				$el.data("hasSubmitOnChangeEvent", true);
			}
		});

		// Button handler for Apply Discount Code dialog on store checkout
		let applyDiscount = function (triggerEl, url) {
			var $this = $(triggerEl);
			var container = $this.parents(".discount-code-container");
			var messageEl = container.siblings(".discount-code-message");

			var codeInput = container.find("input[name=DiscountCode]");

			var options = {
				method: "POST",
				url: url,
				data: { code: codeInput.val() },
				cache: false,
				async: true
			};

			$this.prop("disabled", true);

			messageEl.addClass("d-none");
			messageEl.text(null);

			$.ajax(options)
				.then(function (data) {
					if (data.success) {
						location.reload();

						data.message += " Refreshing...";
					}
					else {
						$this.prop("disabled", false);
					}

					messageEl.removeClass("d-none");
					messageEl.text(data.message);
				},
					function (xhr, textStatus, errorThrown) {
						$this.prop("disabled", false);

						messageEl.removeClass("d-none");
						messageEl.text("Something went wrong, please try again.");
					});
		}

		let shopApplyDiscountUrl = "/umbraco/surface/CheckoutSurface/ApplyDiscount";
		let eventApplyDiscountUrl = "/umbraco/surface/BookingSurface/ApplyDiscount?id=";

		$(document).on("click", "a.js-apply-discount, button.js-apply-discount", function (e) {
			applyDiscount(this, shopApplyDiscountUrl);

			e.preventDefault();
		});
		$(document).on("keydown", "input.js-apply-discount", function (e) {
			if (e.keyCode == 13) {
				applyDiscount(this, shopApplyDiscountUrl);

				e.preventDefault();
				return false;
			}
		});

		$(document).on("click", "a.js-apply-discount-event, button.js-apply-discount-event", function (e) {
			debugger;
			applyDiscount(this, eventApplyDiscountUrl + $("input[name=EventId]").val() + $("input[name=InvoiceId]").val());

			e.preventDefault();
		});
		$(document).on("keydown", "input.js-apply-discount-event", function (e) {
			if (e.keyCode == 13) {
				applyDiscount(this, eventApplyDiscountUrl + $("input[name=EventId]").val() + $("input[name=InvoiceId]").val());

				e.preventDefault();
				return false;
			}
		});
	},

	initPageReady: function () {
		$(document).on("click", ".js-page-number-trigger", function (e) {
			e.preventDefault();

			App.changePage(this);
		});

		$(document).on("submit", "form.js-page-reset-form", function (e, data) {
			if (data && typeof data === "object" && data.pageload) {
				return;
			}

			App.resetFormPage(this);
		});

		$(document).on("submit", "form.js-lock-buttons-on-submit", function () {
			var form = $(this);

			form.find("a.btn,button,input[type=submit]").prop("disabled", true);
		});

		$(document).on("click", ".js-trigger-other", function (e) {
			e.preventDefault();

			var $this = $(this);
			var fieldId = $this.data("fieldid");
			if (!fieldId) return;

			$(`#${fieldId}`).click();
		});

		$(document).on("click", ".js-goback-trigger", function () {
			var $this = $(this);
			var form = $this.closest("form");

			var fieldName = $this.data("field") || "GoBack";

			form.find(`input[name='${fieldName}']`).val("true");

			var validation = $.data(form[0], "validator").settings;
			validation.ignore = "*";

			form.submit();
		});

		$(document).on("change", ".form__file input[type=file]", function (e) {
			var $el = $(this);
			var files = $el.prop("files");

			var label = $el.siblings().find(".form__file--label");

			if (files.length > 0) {
				var text = "";
				for (var i = 0; i < files.length; i++) {
					text += files[i].name + (i !== files.length - 1 ? ", " : "");
				}

				label.text(text);
			}
			else {
				label.text(label.data("default"));
			}
		});


		$('#search-icon').on("click", function () {
			$('#SearchTerm').focus();
		});

		$.validator.unobtrusive.options = {};
		$.validator.unobtrusive.options.errorPlacement = function (err, el) {
			$(el).closest('.input_val').addClass('error');
		}
		$.validator.unobtrusive.options.success = function (err, el) {
			$(el).closest('.error').removeClass('error');
		}

		$.validator.addMethod("requiredif",
			function (value, element, parameters) {
				var targetId = parameters.otherproperty;
				var targetValue = parameters.otherpropertyvalue;

				var otherPropertyValue = (targetValue == null || targetValue == undefined ? "" : targetValue).toString();

				var otherPropertyElement = $('#' + targetId);

				if (otherPropertyElement[0].checked.toString() == otherPropertyValue.toLowerCase()) {
					if (value !== '') {
						var isValid = $.validator.methods.required.call(this, value, element, parameters);
						return isValid;
					}
					return false;
				}

				return true;
			}
		);

		$.validator.unobtrusive.adapters.add("requiredif", ["otherproperty", "otherpropertyvalue"],
			function (options) {
				options.rules["requiredif"] = options.params;
				options.messages["requiredif"] = options.message;
			});

		$.validator.addMethod("minimumage",
			function (value, element, parameters) {
				var targetValue = parameters.age;

				if (value == '')
					return true;

				var dob = new Date(value);
				var today = new Date();
				var minimumDate = new Date(today.getFullYear() - targetValue, today.getMonth(), today.getDate());

				if (dob <= minimumDate) {
					return true;
				}
				else return false;
			}
		);

		$.validator.unobtrusive.adapters.add("minimumage", ["age"],
			function (options) {
				options.rules["minimumage"] = options.params;
				options.messages["minimumage"] = options.message;
			});

		$(document).on("change", ".js-copy-value", function () {
			var $this = $(this);
			var form = $this.parents("form");

			var fieldName = $this.data("copytofield");
			if (!fieldName) {
				return;
			}

			var field = form.find(`input[name='${fieldName}']`);

			field.val($this.val());
			field.trigger("change");
		});

		$(".js-pay-type").click(function (e) {
			e.preventDefault();

			var id = $(this).data("id")

			if (id == "card") {
				$('.js-card').show();
				$('.js-invoice').hide();
				$('.js-directDebit').hide();
				$('.js-pay-type').removeClass('active');
				$(this).addClass('active');
				$("#tAndc").prop('required', false);
				$('#cardholder-name').prop('required', true);
				$('#cardNumber').prop('required', true);
				$('#cardExpiry').prop('required', true);
				$('#cardCVC').prop('required', true);
				$('#flexCheckDefault').prop('required', true);
				$('#DirectDebitSelectFrequency').prop('required', false);
				$('#PayByInvoice').val(false);
				$('#PayByCard').val(true);
				$('#PayByDirectDebit').val(false);
			}
			else if (id == "invoice") {
				$('.js-card').hide();
				$('.js-invoice').show();
				$('.js-directDebit').hide();
				$('.js-pay-type').removeClass('active');
				$(this).addClass('active');
				$("#tAndc").prop('required', true);
				$('#cardholder-name').prop('required', false);
				$('#cardNumber').prop('required', false);
				$('#cardExpiry').prop('required', false);
				$('#cardCVC').prop('required', false);
				$('#flexCheckDefault').prop('required', false);
				$('#DirectDebitSelectFrequency').prop('required', false);
				$('#PayByInvoice').val(true);
				$('#PayByCard').val(false);
				$('#PayByDirectDebit').val(false);
			}
			else if (id == "directDebit") {
				$('.js-card').hide();
				$('.js-invoice').hide();
				$('.js-directDebit').show();
				$('.js-pay-type').removeClass('active');
				$(this).addClass('active');
				$("#tAndc").prop('required', true);
				$('#cardholder-name').prop('required', false);
				$('#cardNumber').prop('required', false);
				$('#cardExpiry').prop('required', false);
				$('#cardCVC').prop('required', false);
				$('#flexCheckDefault').prop('required', false);
				$('#DirectDebitSelectFrequency').prop('required', true);
				$('#PayByInvoice').val(false);
				$('#PayByCard').val(false);
				$('#PayByDirectDebit').val(true);
			}
		});

		$('input[name="SameAsDelivery"]').on('change', function () {
			const hiddenField = $('input[type="hidden"][name="SameAsDelivery"]');
			const checkoutForm = $(this).closest('form');
			const billingForm = checkoutForm.find("#billingDetails");
			const billingFields = billingForm.find("input, select");
			const requiredBillingFields = billingFields.find("input[data-val-required], select[data-val-required]");

			if ($(this).is(':checked')) {
				hiddenField.val(true);
				billingForm.hide();
				requiredBillingFields.each(function (i, el) {
					delete el.dataset.val;
				});
			}
			else {
				hiddenField.val(false);
				billingForm.show();
				requiredBillingFields.each(function (i, el) {
					el.dataset.val = "true";
				});
			}

			checkoutForm.removeData("validator").removeData("unobtrusiveValidation");
			$.validator.unobtrusive.parse(checkoutForm);
		});
	},

	performAjax: function (element, successFunc, errorFunc) {
		var $el = $(element);

		var formData = $el.serialize();
		var options = {
			method: $el.attr("method"),
			url: $el.attr("action"),
			cache: false,
			async: true
		};

		if ($el.hasClass("js-formdata")) {
			formData = new FormData(this);
			options.processData = false;
			options.contentType = false;
		}

		options.data = formData;

		$.ajax(options)
			.then(successFunc, errorFunc);
	},

	resetFormPage: function (element) {
		var $el = $(element);
		var activeElement = $(document.activeElement);

		// If there is an active element, and it is within this form, and it isn't a pagination button, then reset the page
		if (activeElement.length > 0 && $el.has(activeElement) && (!activeElement.hasClass("js-page-number-trigger") && !activeElement.hasClass("page-link"))) {
			var pageVar = $el.data("target-field");

			$el.find(`[name='${pageVar || App.defaults.pageName}']`).val(1);
		}
	},

	changePage: function (element, pageNum) {
		var $el = $(element);
		var page = pageNum !== undefined ? pageNum : $el.data("target-page");

		if (page !== "") {
			var isSafari = navigator.vendor && navigator.vendor.indexOf("Apple") > -1 &&
				navigator.userAgent &&
				navigator.userAgent.indexOf("CriOS") === -1 &&
				navigator.userAgent.indexOf("FxiOS") === -1;

			var pageVar = $el.data("target-field");
			var form = $el.parents("form");

			var varElement = form.find(`[name='${pageVar || App.defaults.pageName}']`);

			varElement.val(page);

			if (isSafari) {
				// Actually disgusting that I have to do this for Safari

				var replaceVarElement = document.createElement("input");
				replaceVarElement.id = varElement.attr("id") + "S";
				replaceVarElement.name = (pageVar && pageVar.replaceAll("\"", "") || varElement.attr("name")) + "S";
				replaceVarElement.type = "hidden";
				replaceVarElement.value = page;

				varElement.parent().append(replaceVarElement);
			}

			form.submit();
		}
	},

	smoothScrollTo: function (element, forceScroll = true, scrollTimeInMs = 500, offset = 0) {
		var $el = $(element);

		if ($el.length > 0) {
			var destinationY = $el.offset().top - 100 - offset;

			if (forceScroll || (window.pageYOffset < destinationY - window.innerHeight || window.pageYOffset > destinationY)) {
				$("html, body").animate({
					scrollTop: destinationY
				}, scrollTimeInMs);
			}
		}
	},

	slideUp: function (e) {
		var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 500;
		e.style.transitionProperty = "height, margin, padding",
			e.style.transitionDuration = t + "ms",
			e.style.boxSizing = "border-box",
			e.style.height = e.offsetHeight + "px",
			e.offsetHeight,
			e.style.overflow = "hidden",
			e.style.height = 0,
			e.style.paddingTop = 0,
			e.style.paddingBottom = 0,
			e.style.marginTop = 0,
			e.style.marginBottom = 0,
			window.setTimeout((function () {
				e.style.display = "none",
					e.style.removeProperty("height"),
					e.style.removeProperty("padding-top"),
					e.style.removeProperty("padding-bottom"),
					e.style.removeProperty("margin-top"),
					e.style.removeProperty("margin-bottom"),
					e.style.removeProperty("overflow"),
					e.style.removeProperty("transition-duration"),
					e.style.removeProperty("transition-property")
			}
			), t);
	},

	slideDown: function (e) {
		var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 500;
		e.style.removeProperty("display");
		var i = window.getComputedStyle(e).display;
		"none" === i && (i = "block"),
			e.style.display = i;
		var s = e.offsetHeight;
		e.style.overflow = "hidden",
			e.style.height = 0,
			e.style.paddingTop = 0,
			e.style.paddingBottom = 0,
			e.style.marginTop = 0,
			e.style.marginBottom = 0,
			e.offsetHeight,
			e.style.boxSizing = "border-box",
			e.style.transitionProperty = "height, margin, padding",
			e.style.transitionDuration = t + "ms",
			e.style.height = s + "px",
			e.style.removeProperty("padding-top"),
			e.style.removeProperty("padding-bottom"),
			e.style.removeProperty("margin-top"),
			e.style.removeProperty("margin-bottom"),
			window.setTimeout((function () {
				e.style.removeProperty("height"),
					e.style.removeProperty("overflow"),
					e.style.removeProperty("transition-duration"),
					e.style.removeProperty("transition-property")
			}
			), t)
	},

	initSwitchList: function () {
		console.log("entered switchlist");
		document.querySelectorAll(".box").forEach((function (i) {
			i.querySelectorAll(".circle span").forEach((function (s) {
				return s.addEventListener("click", (function (s) {
					i.classList.contains("active") ? (i.classList.remove("active"),
						App.slideUp(document.querySelector(".info_box[data-item='".concat(i.dataset.item, "']")), 300)) : (document.querySelectorAll(".box").forEach((function (e) {
							return e.classList.remove("active")
						}
						)),
							document.querySelectorAll(".info_box").forEach((function (e) {
								return App.slideUp(e, 100)
							}
							)),
							i.classList.add("active"),
							setTimeout((function () {
								App.slideDown(document.querySelector(".info_box[data-item='".concat(i.dataset.item, "']")), 300)
							}
							), 100))
				}
				))
			}
			))
		}
		))
	}
}

App.init();